<div class="space-y-5 bg-gray-50/80 px-4 pb-4 pt-3 sm:px-5 sm:pb-5">
  <p class="text-[0.78rem] leading-relaxed text-gray-500">
    Indica stanza e arredi che vuoi vedere:
    <strong class="font-semibold text-gray-700">più sei preciso</strong>, più il
    risultato sarà fedele. Tutto è facoltativo.
  </p>

  <!-- Step 1 · Tipo di stanza -->
  <section>
    <div class="mb-1 flex items-center gap-2">
      <span
        class="flex h-5 w-5 items-center justify-center rounded-full text-[0.65rem] font-bold transition-colors"
        [ngClass]="
          config().roomType
            ? 'bg-blue-casa-doc text-white'
            : 'bg-blue-casa-doc/10 text-blue-casa-doc'
        "
        >1</span
      >
      <span class="text-xs font-bold uppercase tracking-wider text-gray-700">
        Tipo di stanza
      </span>
      @if (!config().roomType) {
        <span class="text-[0.7rem] font-semibold text-blue-casa-doc">
          inizia da qui
        </span>
      }
    </div>
    <p class="mb-2.5 ml-7 text-[0.72rem] leading-relaxed text-gray-500">
      Scegli l'ambiente: l'AI adatta arredi, proporzioni e illuminazione di
      conseguenza.
    </p>

    <div
      role="radiogroup"
      aria-label="Tipo di stanza"
      class="flex flex-wrap gap-2"
    >
      @for (room of roomTypes; track room.value) {
        <button
          type="button"
          role="radio"
          [attr.aria-checked]="config().roomType === room.value"
          (click)="selectRoomType(room.value)"
          class="inline-flex items-center gap-2 rounded-xl border px-3.5 py-2.5 text-left transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-casa-doc/40"
          [ngClass]="
            config().roomType === room.value
              ? 'border-blue-casa-doc bg-blue-casa-doc/5 shadow-sm ring-1 ring-blue-casa-doc'
              : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
          "
        >
          <span class="text-lg leading-none">{{ roomIcons[room.value] }}</span>
          <span
            class="text-[0.8rem] font-semibold leading-tight"
            [ngClass]="
              config().roomType === room.value
                ? 'text-blue-casa-doc'
                : 'text-gray-700'
            "
            >{{ room.label }}</span
          >
        </button>
      }
    </div>
  </section>

  <!-- Step 2 · Opzioni della stanza -->
  <section class="space-y-4">
    <div class="flex items-center gap-2">
      <span
        class="flex h-5 w-5 items-center justify-center rounded-full text-[0.65rem] font-bold transition-colors"
        [ngClass]="
          config().roomType
            ? 'bg-blue-casa-doc text-white'
            : 'bg-gray-200 text-gray-400'
        "
        >2</span
      >
      <span
        class="text-xs font-bold uppercase tracking-wider"
        [ngClass]="config().roomType ? 'text-gray-700' : 'text-gray-400'"
      >
        Opzioni stanza
      </span>
      @if (selectedCount()) {
        <span
          class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-blue-casa-doc/10 px-1.5 text-[0.7rem] font-bold text-blue-casa-doc"
          >{{ selectedCount() }}</span
        >
      }
    </div>

    @if (!config().roomType) {
      <div
        class="rounded-xl border border-dashed border-gray-300 bg-white/60 px-4 py-3 text-center text-xs text-gray-400"
      >
        Seleziona una stanza per sbloccare le opzioni dedicate
      </div>
    }

    @if (config().roomType && exclusiveGroups().length) {
        <p class="-mt-2 ml-7 text-[0.72rem] leading-relaxed text-gray-500">
          Per ogni gruppo scegli <strong class="font-semibold text-gray-700">una</strong>
          variante. Cliccala di nuovo per annullarla.
        </p>
        <div class="space-y-3">
          @for (group of exclusiveGroups(); track group.id) {
            <div>
              <p
                class="mb-1.5 flex items-center gap-1.5 text-[0.7rem] font-semibold uppercase tracking-wide text-gray-500"
              >
                {{ group.label }}
                <span
                  class="rounded-full bg-gray-200/70 px-1.5 py-px text-[0.6rem] font-bold normal-case tracking-normal text-gray-500"
                  >scelta singola</span
                >
              </p>
              <div class="flex flex-wrap gap-1.5">
                @for (option of group.options; track option.id) {
                  <button
                    type="button"
                    (click)="selectGroupOption(group, option.id)"
                    class="rounded-lg border px-3 py-1.5 text-xs font-semibold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-casa-doc/30"
                    [ngClass]="
                      selectedInGroup(group) === option.id
                        ? 'border-transparent bg-blue-casa-doc text-white shadow-sm'
                        : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50'
                    "
                  >
                    {{ option.label }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (config().roomType && standaloneOptions().length) {
        <div>
          <p
            class="mb-1 flex items-center gap-1.5 text-[0.7rem] font-semibold uppercase tracking-wide text-gray-500"
          >
            Aggiungi elementi
            <span
              class="rounded-full bg-gray-200/70 px-1.5 py-px text-[0.6rem] font-bold normal-case tracking-normal text-gray-500"
              >scelta multipla</span
            >
          </p>
          <p class="mb-2 text-[0.72rem] leading-relaxed text-gray-500">
            Aggiungi tutti gli elementi che vuoi: ognuno verrà inserito
            nell'ambiente.
          </p>
          <div class="flex flex-wrap gap-1.5">
            @for (option of standaloneOptions(); track option.id) {
              <button
                type="button"
                [attr.aria-pressed]="isSelected(option.id)"
                (click)="onToggleOption(option)"
                class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-casa-doc/30"
                [ngClass]="
                  isSelected(option.id)
                    ? 'border-blue-casa-doc bg-blue-casa-doc/5 text-blue-casa-doc'
                    : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50'
                "
              >
                @if (isSelected(option.id)) {
                  <svg
                    class="h-3.5 w-3.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.5 7.6a1 1 0 0 1-1.42.006l-3.5-3.5a1 1 0 1 1 1.414-1.414l2.79 2.79 6.795-6.886a1 1 0 0 1 1.415-.006Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                } @else {
                  <span class="text-sm leading-none text-gray-400">+</span>
                }
                {{ option.label }}
              </button>
            }
          </div>
        </div>
      }
    </section>

  <!-- Step 3 · Istruzioni personalizzate -->
  <section>
    <div class="mb-2.5 flex items-center gap-2">
      <span
        class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-casa-doc text-[0.65rem] font-bold text-white"
        >3</span
      >
      <span class="text-xs font-bold uppercase tracking-wider text-gray-700">
        Istruzioni personalizzate
      </span>
      <span class="text-[0.7rem] font-medium text-gray-400">facoltativo</span>
    </div>
    <p class="mb-2.5 ml-7 text-[0.72rem] leading-relaxed text-gray-500">
      Hai un dettaglio che le opzioni qui sopra non coprono? Scrivilo con parole
      tue: si somma alle scelte fatte.
    </p>

    <textarea
      rows="3"
      class="w-full resize-y rounded-xl border border-gray-300 bg-white px-3.5 py-2.5 text-sm leading-6 text-gray-900 placeholder:text-gray-400 focus:border-blue-casa-doc focus:outline-none"
      placeholder="Es. 'aggiungi un tappeto chiaro davanti al divano' oppure 'rendi la luce più calda'…"
      [value]="config().customPrompt"
      (input)="onCustomPromptInput($event)"
    ></textarea>

    <label
      class="mt-3 flex cursor-pointer items-start gap-3 rounded-xl border border-amber-200 bg-amber-50/70 p-3"
    >
      <input
        type="checkbox"
        class="peer sr-only"
        [checked]="config().allowStructuralChanges"
        (change)="onToggleStructuralChanges($event)"
      />
      <span
        class="relative mt-0.5 h-5 w-9 shrink-0 rounded-full bg-gray-300 transition-colors after:absolute after:left-0.5 after:top-0.5 after:h-4 after:w-4 after:rounded-full after:bg-white after:shadow after:transition-transform peer-checked:bg-amber-500 peer-checked:after:translate-x-4"
      ></span>
      <span class="text-xs leading-snug">
        <strong class="block font-bold text-amber-900">
          Abilita modifiche strutturali
        </strong>
        <span class="text-amber-800/80">
          Permette al prompt di modificare muri, aperture, sanitari e altri
          elementi strutturali. L'inquadratura resta comunque invariata.
        </span>
      </span>
    </label>
  </section>
</div>
